import { cn } from '@/shared/lib/cn';
import { HistoryCellView } from './HistoryPill';
import type { HistoryRow } from './historyRows';

/** Karten (Board „Handy · Verlauf“): am Handy und wenn die Liste neben den Details schmal wird. */
export function HistoryCards({
  rows,
  selectedId,
  onSelect,
}: {
  rows: HistoryRow[];
  /** Am Handy gibt es keine Auswahl – das Tippen öffnet das Blatt. */
  selectedId?: string;
  onSelect: (id: string) => void;
}) {
  return (
    <ul className="flex flex-col gap-2 p-3">
      {rows.map((row) => (
        <li key={row.id}>
          <button
            type="button"
            aria-pressed={selectedId === undefined ? undefined : row.id === selectedId}
            onClick={() => onSelect(row.id)}
            className={cn(
              'border-hairline bg-card flex w-full flex-col gap-1 rounded-lg border px-3.5 py-3 text-left',
              row.id === selectedId && 'border-forest bg-forest-soft/40',
            )}
          >
            <span className="flex min-w-0 items-start gap-2">
              <span className="text-ink-soft min-w-0 grow break-words pt-0.5 font-mono text-[11px]">
                {row.card.at}
              </span>
              <HistoryCellView cell={row.card.status} />
            </span>
            <span className="text-sm font-bold">{row.card.main}</span>
            <span className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
              <span className="rounded-pill bg-forest-deep max-w-full truncate px-2 py-0.5 text-[11px] font-bold text-white">
                {row.card.apartment}
              </span>
              <span className="text-ink-soft text-xs">{row.card.sub}</span>
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
